/**
 * Stands in for one value — a name, an email, a role badge — while the row it
 * comes from is still in flight, so a detail page can paint its labels and frame
 * immediately instead of waiting behind one fetch.
 *
 * Pair the width with the value it replaces; the default suits a short field.
 *
 * The bar is shorter than a line of text, so on its own it would leave the row
 * short and push everything below down when the value lands. The invisible
 * zero-width character takes one line in the parent's font and line height,
 * so the placeholder is exactly as tall as the text it stands in for.
 */
export function ValueSkeleton({ className = 'w-40' }: { className?: string }) {
  return (
    <div className="flex items-center" aria-hidden="true">
      <span className="invisible">{'\u200B'}</span>
      <div className={`h-4 animate-pulse rounded bg-muted ${className}`} />
    </div>
  );
}
